module.exports = __webpack_public_path__ + "static/kartpass - logo green-e904222cf05bd1308f85e21493077ccb.svg";